import { createContext } from 'use-context-selector';
import { noop } from 'lodash';

import { TypistSpeed } from '../Typist';

import { MessageOrigin } from './Message.types';

interface MessageContextProps {
  origin: MessageOrigin;
  isTyping: boolean;
  animate?: TypistSpeed;
  onAnimationCompleted: () => void;
}

export const MessageContext = createContext<MessageContextProps>({
  origin: null,
  isTyping: false,
  onAnimationCompleted: noop,
});
